import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";

export class PaymentApi extends BaseApi {
  private static instance: PaymentApi;

  public static get(): PaymentApi {
    if (!this.instance) {
      this.instance = new PaymentApi();
    }
    return this.instance;
  }

  public getPaymentUrl = BaseApi.createEndpoint<
    { clientSecret: string },
    { planCode: string }
  >(HttpMethodEnum.GET, "/payment");
}

export const paymentApi = PaymentApi.get();
